var React = require('react');

function File (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M43 4.05921C43 2.36965 41.8937 1 40.5291 1H12L1 12V49.9408C1 51.6303 2.10626 53 3.4709 53H40.5291C41.8937 53 43 51.6303 43 49.9408V4.05921Z","stroke":"#474747","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M1 12H12V1","stroke":"#474747","strokeWidth":"2","strokeLinejoin":"round","key":1})]);
}

File.defaultProps = {"viewBox":"0 0 44 54","fill":"none"};

module.exports = File;

File.default = File;
